import React, { useState, useEffect } from "react";
import "./AppFeatures.css"; // Link to the CSS file
import image1 from "./img/iPhone 15 Mockup, Perspective.png";
import image2 from "./img/iPhone 15 Mockup, Perspective (2).png";
import image3 from "./img/Iphone 15 Screens Mockup.png";
import image4 from "./img/iPhone 15 Pro Max Mockup, Front View (2).png";

const AppFeatures = () => {
  const features = [
    {
      title: "Admin Panel",
      description: `
        A powerful dashboard to oversee operations, monitor performance, and manage employees 
        with role-based access for administrators and managers. Gain insights through analytics 
        and reporting tools to track key metrics and identify improvement areas. Set up custom 
        alerts and notifications for critical updates, ensuring swift action. Customize the panel 
        to match your organization's structure and operational needs. Simplify complex workflows 
        with intuitive navigation and user-friendly interfaces.
      `,
      image: image1,
    },
    {
      title: "Employee Management",
      description: `
        Efficiently track employee attendance with our Clock-In/Clock-Out system, 
        manage shifts through automated rostering, and monitor employee performance metrics. 
        Allow employees to update availability and request time off directly through the portal. 
        Maintain accurate records for compliance and auditing purposes. Enhance communication 
        through built-in messaging and notification systems. Streamline hiring processes by 
        integrating recruitment tools for onboarding new team members seamlessly.
      `,
      image: image2,
    },
    {
      title: "Job Assignment and Tracking",
      description: `
        Seamlessly assign tasks to employees, track job progress in real-time, 
        and ensure timely completion. Employees can update statuses directly in the app. 
        Visualize task timelines with Gantt charts and manage priorities with drag-and-drop features. 
        Enhance accountability by setting deadlines and assigning ownership. Keep all stakeholders 
        informed with automated updates and detailed progress reports. Monitor productivity trends 
        to optimize resource allocation and improve efficiency.
      `,
      image: image3,
    },
    {
      title: "Invoicing and Financial Management",
      description: `
        Automate invoicing based on timesheets, track payments, and manage financial records 
        with accuracy, ensuring compliance with NDIS standards. Generate detailed financial reports 
        to support strategic decision-making. Simplify tax filing with built-in tools that organize 
        expenses and revenue. Enable secure online payment options for faster transactions. Provide 
        clients with transparent, professional invoices tailored to their requirements. Reduce manual 
        errors with advanced reconciliation tools that sync seamlessly with accounting software.
      `,
      image: image4,
    },
  ];
  
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
    }, 4000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [features.length]);

  return (
    <section className="features-section">
      <div className="features-wrapper">
        {/* Left Section */}
        <div className="features-left">
          <h2 className="features-title">Our App Features</h2>
          {features.map((feature, index) => (
            <div
              key={index}
              className={`feature-details ${
                index === currentIndex ? "active" : ""
              }`}
            >
              <h3 className="feature-heading">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>



        {/* Right Section */}
        <div className="features-right">
          <div className="image-slider">
            {features.map((feature, index) => (
              <img
                key={index}
                src={feature.image}
                alt={feature.title}
                className={`slider-image ${
                  index === currentIndex ? "visible" : "hidden"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};


export default AppFeatures;
